import styled from 'styled-components';

export const MenuButton = styled.button`
    background: none;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 36px;
    img {
        width: 100%;
    }
`;